import React, { Component } from 'react';
import axios from 'axios';
import newsItems from '../dummy_data/newsItems.json';
import config from '../dummy_data/configuration.json';
import Navigation from '../components/Navigation'
import News from '../components/News'
import Breadcrumb from '../components/Breadcrumb'
import NewsList from '../components/NewsList'
// import Footer from '../components/Footer'
import SimpleFooter from '../components/SimpleFooter'
import {BreadcrumbItems} from '../dummy_data/localizationItems.json'


class NewsPage extends Component {

	constructor () {
		super()
		this.state = {
			footerItem: {},
			newsItems: [],
			showMobileMenu: false
		}
	}

	componentWillMount() {
		// console.log(this.props.match.params);
		if(config.useDummyData){
  			this.setState({ newsItems: newsItems });
  		}
  		else if(this.props.match.params.newsType){
  			this.handleRefreshData(this.props.match.params.newsType);
  		}

  		this._getFooter();
	}

	componentWillReceiveProps(nextProps) {
		if(config.useDummyData){
  			this.setState({ newsItems: newsItems });
  		}
  		else if(nextProps.match.params.newsType){
  			this.handleRefreshData(nextProps.match.params.newsType);
  		}
	}

	handleShowHideMobileMenu(){
		this.setState({
	      showMobileMenu: !this.state.showMobileMenu
	    });
	}

	handleScreenClick(event){
		if(event.target.tagName !== "A" && event.target.className !== "fa fa-bars" && event.target.className !== "navigation-folded" && event.target.offsetParent.className.indexOf("mobile") < 0){
			this.setState({
		      showMobileMenu: false
		    });
		}
	}

	handleRefreshData = (newsType) => {
		axios({
	        method: 'GET',
	        url: `${config.newsItemsAction}?newsType=${newsType}`,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            // console.log(res);
            this.setState({
            	newsItems: res.data
            });
        }).catch((err)=>{
            console.log(err.status);
        })
	}

	_getFooter = () => {
		axios({
	        method: 'GET',
	        url: config.footerAction,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            // console.log(res);
            this.setState({
            	footerItem: res.data
            });
        }).catch((err)=>{
            console.log(err.status);
        })
	}

	getField = (fieldName) =>{
		return localStorage.getItem("isEnglish") === "true"? BreadcrumbItems.find(i => i.fieldName === fieldName).eName : BreadcrumbItems.find(i => i.fieldName === fieldName).name;
	}

	render() {
		const location = [];
		location.push({
			name: this.getField("News"),
			url: "/news/All"
		});

		if(this.props.match.params.newsType !== "All"){
			location.push({
				name: this.props.match.params.newsType === "Enterprise"? this.getField("CorporateNews") : this.getField("IndustryDynamic"),
				url: this.props.match.url
			});
		}		

		// console.log(this.props.match);
		return(
			<div onClick={this.handleScreenClick.bind(this)}>
				<Navigation showMobileMenu={ this.state.showMobileMenu } handleShowHideMobileMenu={ this.handleShowHideMobileMenu.bind(this)}/>
				<div className="banner"><img src={require("../img/news.jpg")} alt="" /></div>
				<div className="content-container">
					<Breadcrumb location={location} />
					<NewsList items={this.state.newsItems} />
					
					<div className="news-list-mobile">
					<News items={this.state.newsItems} newsType={this.props.match.params.newsType} />
				</div>
				</div>
				
				{/*<Footer item={this.state.footerItem} />*/}
				<SimpleFooter item={this.state.footerItem} />
			</div>
		)
	}
}

export default NewsPage;


// WEBPACK FOOTER //
// ./src/pages/NewsPage.js